import { baseRoute } from '../../../constants/routes';

export const GET_QUIZ_PLAYER_COVER = baseRoute + '/get-player-cover';
export const START_GAME = baseRoute + '/start-play-session';
export const ANSWER_GAME_QUESTION = baseRoute + '/question-answer';
export const GET_NEXT_QUESTION = baseRoute + '/get-next-question';
export const EXIT_GAME_ROUTE = baseRoute + '/exit-game';

export const LINK_TRACKING_QUIZ_ROUTE = baseRoute + '/save-adv-quiz-view';

export const SEND_USER_DETAILS = 'SEND_USER_DETAILS';
export const SEND_USER_DETAILS_SUCCESS = 'SEND_USER_DETAILS_SUCCESS';

export const SET_TIMER_VALUE = 'SET_TIMER_VALUE';
export const SET_TIMER_VALUE_SUCCESS = 'SET_TIMER_VALUE_SUCCESS';
export const SET_EVENT_AUDIO_VALUE = 'SET_EVENT_AUDIO_VALUE';
export const SET_EVENT_AUDIO_VALUE_SUCCESS = 'SET_EVENT_AUDIO_VALUE_SUCCESS';

export const ADVSOURCE_FEEDBACK = 'feedback';
export const ADVSOURCE_RESULT_IMAGE = 'result_img';
export const ADVSOURCE_RESULT_BUTTON = 'result_btn';